$(document).ready(function () {


    // industries //

    // var industries = new Swiper('.js-industries', {
    //     // loop: true,
    //     slidesPerView: 1,
    //     breakpoints: {
    //         320: {
    //             slidesPerView: 1,
    //             // spaceBetween: 25,
    //             // loop: true,
    //         },

    //         414: {
    //             slidesPerView: 1,
    //             // spaceBetween: 25,
    //             // loop: true,
    //         },

    //         769: {
    //             slidesPerView: 1,
    //             // loop: true,
    //         },
    //     },
    //     navigation: {
    //         nextEl: '.swiper-button-next',
    //         prevEl: '.swiper-button-prev',
    //     },
    //     pagination: {
    //         el: '.swiper-pagination',
    //     }

    // });


    var industries = new Swiper('.js-industries', {        
        slidesPerView: "auto",
        slidesPerView: 2,
        centeredSlides: false,        
        spaceBetween: 0,
        loop: false,
        speed: 3000,        
        autoplay: {
            delay: 40000,
            disableOnInteraction: false,
        },    
        breakpoints: {
            // 360: {
            //     slidesPerView: 1,
                
            // },

            // 375: {
            //     slidesPerView: 1,
                
            // },

            // 414: {
            //     slidesPerView: 1.5,
               
            // },

            768: {   
                slidesPerView: "auto",
                centeredSlides: true,
                slidesPerView: 1.5,
                spaceBetween: 20,
                loop: true,
                speed: 2000,        
                autoplay: {
                    delay: 1000,                   
                },
                pagination: ".swiper-pagination",
                paginationClickable: true,                
            },
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
        }

    });

    // // industries //

    var infrastructuresilicon = new Swiper('.js-infrastructure', {
        slidesPerView: "auto",
        slidesPerView: 1,
        centeredSlides: false,        
        spaceBetween: 0,
        loop: false,
        speed: 3000,        
        autoplay: {
            delay: 40000,
            disableOnInteraction: false,
        },    
        // slidesPerView: 1,
        breakpoints: {
            // 360: {
            //     slidesPerView: 1,
            //     // spaceBetween: 25,
            //     // loop: true,
            // },

            // 375: {
            //     slidesPerView: 1,
            //     // spaceBetween: 25,
            //     // loop: true,
            // },

            // 414: {
            //     slidesPerView: 1,
            // },

            // 769: {
            //     slidesPerView: 2.5,
            //     // loop: true,
            // },
            768: {
                slidesPerView: "auto",
                centeredSlides: true,
                slidesPerView: 1,
                spaceBetween: 20,
                loop: true,
                speed: 2000,        
                autoplay: {
                    delay: 1000,                   
                },
                pagination: ".swiper-pagination",
                paginationClickable: true,   
            },
        },
        navigation: {
            nextEl: '.swiper-button-next-infrastructure',
            prevEl: '.swiper-button-prev-infrastructure',
        },
        pagination: {
            el: '.swiper-pagination',
        }

    });



})

// new side sticky

// mechanical expertise

var expertise = new Swiper('.js-expertise', {
    // loop: true,
    slidesPerView: 3.5,
    breakpoints: {
        320: {
            slidesPerView: 1.5,
        },

        414: {
            slidesPerView: 1.5,
        },

        769: {
            slidesPerView: 2.5,
        },
        1366: {
            slidesPerView: 2.5,
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
    }
});

